// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../public/images/logo_image.png");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".iframestyleset {\n  width: auto;\n  height: 98%;\n  overflow: hidden;\n}\n#iframeMapViewComponent {\n  margin-top: -10px;\n}\n.imgs_logo {\n  height: 25px;\n  width: 100px;\n  margin-top: -2%;\n  margin-left: 69%;\n  background: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iframestyleset": "iframestyleset",
	"iframeMapViewComponent": "iframeMapViewComponent",
	"imgs_logo": "imgs_logo"
};
module.exports = ___CSS_LOADER_EXPORT___;
